import React from "react";
import styled from "styled-components";
import spinner from "./spinner.svg";
const AnimationContainer = styled.div`
  height: 100%;
  display: flex;
  position: absolute;
  width: 100%;
  z-index: 8;
  top: 0;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.background ? props.background : "rgba(0,0,0,0.35)"};
`;

const SmallLoading = ({ background }) => {
  return (
    <AnimationContainer background={background}>
      <img src={spinner} width="50" alt="spinner" />
    </AnimationContainer>
  );
};

export default SmallLoading;
